import React, { FormEvent, useState } from 'react'
import {
  Box,
  Button,
  ButtonProps,
  FormControl,
  FormLabel,
  OutlinedInput,
  Paper,
  PaperProps,
  styled,
  Typography
} from '@mui/material'
import { useSignInMutation } from '@api/user'
import { AuthDTO } from '@src/types/user'
import Loading from '@components/Loading'
import { ApiError } from '@src/types/api'

type LoginFormProps = PaperProps & {
  onSignIn?: (accessToken: string) => void;
}

const LoginForm = styled(({ onSignIn, ...props }: LoginFormProps) => {
  const [ signIn, signInResp ] = useSignInMutation()

  const [ restorePassword, setRestorePassword ] = useState(false)
  const [ error, setError ] = useState<string | null>(null)

  const submitHandle = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const data = Object.fromEntries((new FormData(e.currentTarget)).entries())
    const resp = await signIn(data as AuthDTO)

    if(resp.error) {
      setError((resp.error as ApiError).data.message)
    } else {
      if(onSignIn) {
        onSignIn(resp.data.access_token)
      }
    }
  }

  return (
    <Paper {...props}>

      {signInResp.isLoading && <Loading size={80} thickness={1.35} />}

      {restorePassword ? (
        <>
          <Box sx={{ mb: 4 }}>
            <Typography fontSize={20} sx={{ mb: 3 }}>
              Забыл пароль
            </Typography>
            <Typography variant="body1">
              Обратитесь к администратору, он сбросит текущий пароль, на эл. почту будет отправлен новый.
            </Typography>
          </Box>
          <FormButton onClick={() => setRestorePassword(false)}>
            Понятно
          </FormButton>
        </>
      ) : (
        <form onSubmit={submitHandle} onFocus={() => setError(null)}>
          <Typography fontSize={20} sx={{ mb: 2 }}>
            Личный кабинет
          </Typography>

          <FormControl fullWidth>
            <FormLabel>Эл. почта</FormLabel>
            <OutlinedInput size="small" name="email" required fullWidth error={!!error} />
          </FormControl>

          <FormControl fullWidth>
            <FormLabel>Пароль</FormLabel>
            <OutlinedInput size="small" name="password" required fullWidth type="password" error={!!error} />
          </FormControl>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
            <FormButton type="submit">
              Вход
            </FormButton>
            <Button variant="text" color="info" onClick={() => setRestorePassword(true)}>
              Забыл пароль
            </Button>
          </Box>
        </form>
      )}

    </Paper>
  )
})(({ theme: { spacing }}) => ({
  maxWidth: 415,
  minHeight: 335,
  padding: spacing(3, 4, 4),
  boxSizing: 'border-box',
  position: 'relative',
  '.MuiFormControl-root': {
    marginBottom: spacing(3),
  },
}))

const FormButton = (props: ButtonProps) => (
  <Button {...props} variant="contained" color="secondary" size="large" sx={{ px: 6 }} />
)

export default LoginForm